import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class PartnersApi extends Api {
  constructor() {
    super('website/partners/');
  }

  // GET all with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // CREATE partner
  create = (data) => {
    const formData = new FormData();

    // Required IT fields
    if (data.title_it || data.title) {
      formData.append('partner[title_it]', data.title_it || data.title);
    }
    if (data.description_it || data.description) {
      formData.append(
        'partner[description_it]',
        data.description_it || data.description,
      );
    }
    if (data.description_short_it || data.description_short) {
      formData.append(
        'partner[description_short_it]',
        data.description_short_it || data.description_short,
      );
    }
    if (data.description_short) {
      formData.append('partner[description_short]', data.description_short);
    }
    if (data.link_it || data.link) {
      formData.append('partner[link]', data.link_it || data.link);
    }
    if (data.discount_it || data.discount) {
      formData.append(
        'partner[discount_it]',
        data.discount_it || data.discount,
      );
    }
    if (data.shopping_center_id) {
      formData.append('partner[shopping_center_id]', data.shopping_center_id);
    }
    if (data.image) {
      formData.append('partner[image]', data.image);
    }
    if (data.image_mini) {
      formData.append('partner[image_mini]', data.image_mini);
    }

    // Optional multilingual fields (if backend supports)
    if (data.title_en) {
      formData.append('partner[title_en]', data.title_en);
    }
    if (data.title_fr) {
      formData.append('partner[title_fr]', data.title_fr);
    }
    if (data.description_en) {
      formData.append('partner[description_en]', data.description_en);
    }
    if (data.description_fr) {
      formData.append('partner[description_fr]', data.description_fr);
    }
    if (data.description_short_en) {
      formData.append(
        'partner[description_short_en]',
        data.description_short_en,
      );
    }
    if (data.description_short_fr) {
      formData.append(
        'partner[description_short_fr]',
        data.description_short_fr,
      );
    }
    if (data.link_en) {
      formData.append('partner[link_en]', data.link_en);
    }
    if (data.link_fr) {
      formData.append('partner[link_fr]', data.link_fr);
    }
    if (data.discount_en) {
      formData.append('partner[discount_en]', data.discount_en);
    }
    if (data.discount_fr) {
      formData.append('partner[discount_fr]', data.discount_fr);
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/partners`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPDATE partner
  update = (id, data) => {
    const formData = new FormData();

    if (data.title_it || data.title) {
      formData.append('partner[title_it]', data.title_it || data.title);
    }
    if (data.description_it || data.description) {
      formData.append(
        'partner[description_it]',
        data.description_it || data.description,
      );
    }
    if (data.description_short_it || data.description_short) {
      formData.append(
        'partner[description_short_it]',
        data.description_short_it || data.description_short,
      );
    }
    if (data.link_it || data.link || data.link_it === '' || data.link === '') {
      formData.append('partner[link]', data.link_it || data.link);
    }
    if (data.discount_it || data.discount) {
      formData.append(
        'partner[discount_it]',
        data.discount_it || data.discount,
      );
    }
    if (data.shopping_center_id) {
      formData.append('partner[shopping_center_id]', data.shopping_center_id);
    }
    if (data.image) {
      formData.append('partner[image]', data.image);
    }
    if (data.image_mini) {
      formData.append('partner[image_mini]', data.image_mini);
    }

    if (data.title_en) {
      formData.append('partner[title_en]', data.title_en);
    }
    if (data.title_fr) {
      formData.append('partner[title_fr]', data.title_fr);
    }
    if (data.description_en) {
      formData.append('partner[description_en]', data.description_en);
    }
    if (data.description_fr) {
      formData.append('partner[description_fr]', data.description_fr);
    }
    if (data.description_short_en) {
      formData.append(
        'partner[description_short_en]',
        data.description_short_en,
      );
    }
    if (data.description_short_fr) {
      formData.append(
        'partner[description_short_fr]',
        data.description_short_fr,
      );
    }
    if (data.link_en) {
      formData.append('partner[link_en]', data.link_en);
    }
    if (data.link_fr) {
      formData.append('partner[link_fr]', data.link_fr);
    }
    if (data.discount_en) {
      formData.append('partner[discount_en]', data.discount_en);
    }
    if (data.discount_fr) {
      formData.append('partner[discount_fr]', data.discount_fr);
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/partners/${id}`,
      method: 'PUT',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // DELETE partner
  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/partners/${id}`,
      method: 'DELETE',
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET filters (shopping_centers, companies, etc)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new PartnersApi();
